export default __webpack_public_path__ + "3ae6372.png";